/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InsuranceType } from './InsuranceType';
import {
    InsuranceTypeFromJSON,
    InsuranceTypeFromJSONTyped,
    InsuranceTypeToJSON,
} from './InsuranceType';

/**
 * 
 * @export
 * @interface PatientInsurance
 */
export interface PatientInsurance {
    /**
     * 
     * @type {InsuranceType}
     * @memberof PatientInsurance
     */
    type: InsuranceType;
    /**
     * Insurance state
     * @type {string}
     * @memberof PatientInsurance
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    plan_number?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    medicaid_number?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    medicare_number?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    group_number?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    plan_name?: string;
    /**
     * Insurance payor name
     * @type {string}
     * @memberof PatientInsurance
     */
    payor: string;
}

/**
 * Check if a given object implements the PatientInsurance interface.
 */
export function instanceOfPatientInsurance(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "payor" in value;

    return isInstance;
}

export function PatientInsuranceFromJSON(json: any): PatientInsurance {
    return PatientInsuranceFromJSONTyped(json, false);
}

export function PatientInsuranceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientInsurance {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': InsuranceTypeFromJSON(json['type']),
        'state': json['state'],
        'plan_number': !exists(json, 'plan_number') ? undefined : json['plan_number'],
        'medicaid_number': !exists(json, 'medicaid_number') ? undefined : json['medicaid_number'],
        'medicare_number': !exists(json, 'medicare_number') ? undefined : json['medicare_number'],
        'group_number': !exists(json, 'group_number') ? undefined : json['group_number'],
        'plan_name': !exists(json, 'plan_name') ? undefined : json['plan_name'],
        'payor': json['payor'],
    };
}

export function PatientInsuranceToJSON(value?: PatientInsurance | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': InsuranceTypeToJSON(value.type),
        'state': value.state,
        'plan_number': value.plan_number,
        'medicaid_number': value.medicaid_number,
        'medicare_number': value.medicare_number,
        'group_number': value.group_number,
        'plan_name': value.plan_name,
        'payor': value.payor,
    };
}

